<template>
  <div>
    <b-modal id="modal-upload-operation" size="lg" centered :title="$t('workspace.bulk-invite-result')" hide-footer>
      <div v-if="uploadResponse && uploadResponse.success.length > 0">
        <h5 class="text-success">{{ $t("common.success") }}</h5>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ $t("common.name-surname2") }}</th>
              <th scope="col">Email</th>
              <th scope="col">{{ $t("role.text") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in uploadResponse.success" :key="item.id">
              <th>{{ item.name }}</th>
              <td>{{ item.email }}</td>
              <td>{{ item.role | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="uploadResponse && uploadResponse.failed.length > 0">
        <h5 class="text-danger mt-4">{{ $t("common.failed") }}</h5>

        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ $t("common.name-surname2") }}</th>
              <th scope="col">Email</th>
              <th scope="col">{{ $t("role.text") }}</th>
              <th scope="col">{{ $t("alert.error") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in uploadResponse.failed" :key="item.id">
              <th>{{ item.name }}</th>
              <td>{{ item.email }}</td>
              <td>{{ item.role | translate }}</td>
              <td>{{ item.cause }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <div class="alert alert-warning">
      <ul>
        <li>
          <p>{{ $t("workspace.invite-template.p1") }}</p>
        </li>
        <li>
          <p v-html="$t('workspace.invite-template.p2', { role: $t('workspace.roles.accessor'), tag: 'DEFAULT_ACCESSOR_TO_ORGANIZATIONS' })"></p>
        </li>
        <li>
          <p v-html="$t('workspace.invite-template.p3', { role: $t('workspace.roles.member'), tag: 'WORKSPACE_MEMBER' })"></p>
        </li>
        <li>
          <p v-html="$t('workspace.invite-template.p4', { role: $t('workspace.roles.admin'), tag: 'WORKSPACE_ADMIN' })"></p>
        </li>

        <li>
          <p v-html="$t('workspace.invite-template.p5')"></p>
        </li>
      </ul>
    </div>
    <div class="alert alert-info">{{ $t("workspace.invite-template.p6") }}</div>
    <div>
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td>{{ $t("common.name-surname2") }}</td>
            <td>email</td>
            <td>WORKSPACE_MEMBER</td>
            <td>tr</td>
          </tr>
          <tr>
            <td>{{ $t("common.name-surname2") }}</td>
            <td>email</td>
            <td>DEFAULT_ACCESSOR_TO_ORGANIZATIONS</td>
            <td>en</td>
          </tr>
          <tr>
            <td>{{ $t("common.name-surname2") }}</td>
            <td>email</td>
            <td>WORKSPACE_ADMIN</td>
            <td>fr</td>
          </tr>
          <tr>
            <td>{{ $t("common.name-surname2") }}</td>
            <td>email</td>
            <td>WORKSPACE_ADMIN</td>
            <td>de</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card bg-light">
      <div class="card-body">
        <file-rocket :allowedFormats="allowedFormats" @response="handleUploadResponse" :maxFileSize="5242880" :targetUrl="targetUrl"></file-rocket>
      </div>
    </div>
  </div>
</template>

<script>
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import FileRocket from "../../components/common/form/file-rocket.vue";

export default {
  props: { workspace: { type: Object } },
  components: { FileRocket },
  data() {
    return {
      uploadResponse: undefined,
      targetUrl: "/workspace/bulk-invite",
      allowedFormats: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
      form: {
        name: undefined,
        email: undefined,
        language: undefined,
        workspaceRole: this.$store.getters["workspaceRole/WorkspaceRoleMember"],
      },
      workspaceRoles: this.$store.getters["workspaceRole/roles"],
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(40),
      },
      workspaceRole: {
        required,
      },
      email: {
        email,
        required,
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["workspace/isUpdating"];
    },
    languages() {
      return this.$store.getters["localization/languages"];
    },
  },
  mounted() {
    this.form.language = this.languages.find((l) => l.language == "tr");
  },
  methods: {
    handleUploadResponse(event) {
      if (event && event?.status !== 200) {
        this.$handleHttpErrorByStatusCode(event?.error);
      }
      this.$emit("onSent");
      this.uploadResponse = event.data;
      this.$root.$emit("bv::show::modal", "modal-upload-operation");
    },
    onSelect() {
      this.$forceUpdate();
    },
  },
};
</script>
